
/* injects from baggage-loader */

'use strict';

import sellerSearchDirective from './sellerSearch.directive';
import sellerSearchConstant from './sellerSearch.constant';
/**
 * Seller search module definition.
 */
const sellerSearchModule = angular.module('sellerSearch.module', []);

sellerSearchModule.directive('sellerSearch', sellerSearchDirective);
sellerSearchModule.constant('sellerSearchConstant', sellerSearchConstant);

export default sellerSearchModule;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerSearch/sellerSearch.module.js